const fileExtension = [".xls", "xlsx"];

export const checkFileFormat = (file, fileExtensions = fileExtension) => {
    const fileType = file.split('.').pop().toLowerCase();
    return fileExtensions.includes(fileType);
}